import BetSlipOdd from '@core/models/base/BetSlipOdd';
import ISelection from '@models/betSlip/ISelection';
import { RecreatableTicketEventOdd } from '@shared/tickets/RecreatableTicket';
import { SelectionSourceType } from '@superbet-group/web.types';

export function getEventOddMap(
    selections: ISelection[],
): Record<number, Set<string>> {
    return selections.reduce((oddMap, selection) => {
        if (!selection.odd) {
            return oddMap;
        }
        const eventId = selection.getEventId();
        if (!oddMap[eventId]) {
            // eslint-disable-next-line no-param-reassign
            oddMap[eventId] = new Set();
        }
        const oddId = selection.getOddUuid();
        if (!oddId) {
            return oddMap;
        }
        oddMap[eventId].add(oddId);
        return oddMap;
    }, {} as Record<number, Set<string>>);
}

export async function recreateOddFromTicketOdd(
    odd: RecreatableTicketEventOdd | undefined,
    marketId: number | undefined,
    getBetBuilderBetSlipOdd: (oddUuid: BetSlipOdd['uuid']) => Promise<BetSlipOdd | undefined>,
): Promise<BetSlipOdd | null> {
    if (odd?.sourceType !== SelectionSourceType.BetBuilder) {
        return null;
    }

    const betBuilderOdd = await getBetBuilderBetSlipOdd(odd.oddUuid);

    if (odd?.name == null && betBuilderOdd == null) {
        return null;
    }

    return {
        name: betBuilderOdd?.name ?? odd.name,
        isLocked: false,
        marketId: betBuilderOdd?.marketId ?? marketId ?? 0,
        marketName: betBuilderOdd?.name ?? odd.name,
        marketUuid: betBuilderOdd?.marketUuid ?? odd.marketUuid,
        description: betBuilderOdd?.name ?? odd.name,
        specialBetValue: betBuilderOdd?.specialBetValue ?? odd.specialValue ?? '',
        isFinished: false,
        isShownOnOffer: true,
        isBonusable: false,
        isInPromotion: false,
        uuid: betBuilderOdd?.uuid ?? odd.oddUuid,
        isSuperbet: true,
        sourceType: betBuilderOdd?.sourceType ?? odd.sourceType ?? SelectionSourceType.BetBuilder,
        value: betBuilderOdd?.value ?? odd.coefficient,
        id: betBuilderOdd?.id ?? parseInt(odd.oddId, 10),
        legs: betBuilderOdd?.legs,
    };
}
